import Popper from 'popper.js/dist/umd/popper.js';

window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = Popper;
} catch (e) {
   console.log('bootstrao.js ERROR', e);
}



// WEBPACK FOOTER //
// ./src/js/bootstrap.js